export default {
  heading:
    'We believe everyone should have the ability to help animals in need',
  ourStory: 'Our Story',
  text: `Cheerie is a social business founded by a couple of dog lovers in 2021
          after a visit to a local animal rescue shelter to adopt a homeless
          pet… <br /><br />
          Like many animal lovers, we grew up with dogs in our family household.
          We’ve gained a deep connection to them that hasn’t left us since we
          were children. <br /><br />
          When it came time to get a new pet, we decided to adopt a rescue dog.
          But when we toured the shelter, we were shocked by how many pets had
          been abandoned, and by just how bad the conditions were. The staff at
          the shelter were doing everything they could, but the funds were
          lacking.<br /><br />
          The image haunted us. We knew we had to do more to help these animals
          in need. By talking to friends, we found out many of them wanted to
          help animals. But they either didn’t have the space to adopt or the
          extra money to donate. <br /><br />
          We had a history working in the online space and decided to leverage
          our knowledge to create a way for people to help animals with their
          internet habits. All without having to spend a single penny
          themselves. Since then, we’ve built a hybrid team of animal and tech
          lovers to make this social business a reality. And animal saving
          search engine Cheerie is the result!`,
  aboutTheCharity: 'About the charity',
  aboutCharityText:
    'In America, more than 1,700 dogs and cats are killed every single day because they don’t have safe places to call home. That’s more than one animal every minute. And many of these helpless animals are killed purely for convenience or due to lack of space. Best Friends have been working since 1984 to change all this…',
  bubbleLeft: {
    heading: 'The Mission To Turn America’s Shelters No-Kill',
    content:
      'To save vulnerable animals, Best Friends started the ‘No-Kill 2025’ movement. They aim to give all pets second chances and happy homes, and make every shelter in America no-kill by 2025.',
  },
  bubbleRight: {
    heading: 'Millions Of Lives Already Saved',
    content:
      'Between 2016 and 2019 alone, Best Friends contributed to a 58% reduction in animals needlessly dying, and saved 2.3 million additional lives.',
  },
  contribute:
    'Want to contribute to charities like ‘Best Friends’ for free every time you search the web?',
  mealsOffered: 'meals offered to animals in shelters by Cheerie.',
  dogsServed: 'Dogs Served',
  catsServed: 'Cats Served',
  breedsServed: 'Breeds Served',
  certificates: 'Certificates issued',
  whereAreWe: 'Where Are We In The World',
  getInTouch: 'Get In Touch',
};
